import React, { useContext } from 'react'
import { Product } from '@/src/types/api-types'
import { ProductsBasket } from '@/type/basket'
import UpdateIcon from '@mui/icons-material/Update'
import { isAfter } from 'date-fns'
import Button from '@/components/Common/Button'
import ProfileContext from '../Context/ProfileContext'
import { useConfirm } from 'material-ui-confirm'
import WarningIcon from '@mui/icons-material/Warning'
import { useQueryClient } from '@tanstack/react-query'
import { useRestMutation } from '@/lib/hook/tanstackQuery'
import { ApiQueryEndpoint } from '@/src/ApiQueryEndpoint'
import { ApiMutationEndpoint } from '@/src/ApiMutationEndpoint'

type Props = {
  product: Product | ProductsBasket
  mode?: string
}

export const getDateAvailableProduct = (product: Product | ProductsBasket) => {
  return product.avail_since && isAfter(new Date(Number(product.avail_since) * 1000), new Date())
    ? product.avail_since
    : product?.planning_shipping_current?.date_close
}

const BasketProductPlanningButton: React.FC<Props> = ({ product, mode = 'DEGROUP' }) => {
  const { basketAllRefetcher } = useContext(ProfileContext)
  const confirm = useConfirm()

  const queryClient = useQueryClient()
  const { mutateAsync: updateDateClose } = useRestMutation<any, Error, any>({
    ...ApiMutationEndpoint.BASKET.UPDATE_PRODUCT,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [ApiQueryEndpoint.BASKET.GET_BASKET.endpoint] })
    },
  })

  const getQuantityToUse = (product: Product | ProductsBasket) => {
    return parseInt(product.amount) > parseInt(product.in_stock) ? product.in_stock : product.amount
  }

  const handleChangeShippingExplodeDateClose = async product => {
    confirm({
      description:
        mode == 'DEGROUP' ? (
          <>
            <div>
              <p>
                <WarningIcon />
                Je veux recevoir immédiatement les produits en stock. En dégroupant ma commande, je
                paierai des frais de livraison pour chaque envoi et ne pourrai plus bénéficier du
                franco de port. Je recevrai donc {getQuantityToUse(product)} produits tout de suite
                et le reste à sa date de disponibilité.
              </p>
            </div>
          </>
        ) : (
          <>
            <div>
              <p>
                <WarningIcon />
                Je veux recevoir les produits en stock plus tard.
              </p>
            </div>
          </>
        ),
    }).then(() => {
      updateDateClose({
        company_id: product.company_id,
        product_id: product.product_id,
        item_id: product.item_id,
        mode,
      }).then(() => basketAllRefetcher())
    })
  }

  return (
    <div key={product.product_id} className={'mt-2'}>
      <Button
        onClick={() => handleChangeShippingExplodeDateClose(product)}
        variant="outlined"
        style={{ color: '#E34F00', borderColor: '#E34F00' }}
        size="small"
      >
        <div style={{ display: 'flex', width: '100%', alignItems: 'center', marginLeft: 'auto' }}>
          <UpdateIcon style={{ color: '#E34F00' }} width={4} height={8} />
          <div className="flex items-center font-bold text-[#E34F00] text-xs whitespace-nowrap ml-2 mr-2 flex-wrap">
            Recevoir mes {getQuantityToUse(product)} produits{' '}
            {mode == 'DEGROUP' ? 'maintenant' : 'plus tard'}{' '}
          </div>
        </div>
      </Button>
    </div>
  )
}
export default BasketProductPlanningButton
